var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_d6144cdc"]},_vm.$listeners),[_c('cube-button',{attrs:{"public-id":"xxxxxx","open-type":"lifestyle","tip":"需在支付宝小程序环境预览"},on:{"followLifestyle":(e)=>_vm.__invoke(e, [["onFollowLifestyle"]])}},[_vm._v("关注生活号")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }